
export default {
  classPanel: {
    leaveClass: 'Leave class',
    title: 'Class',
    handTest: {
      intro: "To better assist you, I'd like to know your hand size. It will take less than 5 minutes!",
      skip: 'Skip',
      take: 'Take the test',
    }
  },
  classTypeTitle: {
    pianoBoth: 'Hands Together',
    pianoLeft: 'Left Hand',
    pianoRight: 'Right Hand',
    consolidation: 'Chaining',
    sing: 'Singing',
  },
  classType: {
    pianoBoth: 'Hands Together',
    pianoLeft: 'Left Hand',
    pianoRight: 'Right Hand',
    consolidation: 'Chaining',
    sing: 'Singing',
  },
  demo: {
    title: 'Demo',
    description: 'Watch (without playing) what we will work on next.',
    name: 'Demo',
    shortName: 'Demo',
  },
  resumeDemo: {
    title: 'Resume Demo',
    description: 'Here is what you started and what we will continue to work on.',
  },
  consolidation: {
    title: 'Demo',
    description: 'Watch (without playing) all the parts you will chain in the following order: {partListText}',
  },
  playClass: {
    tips: {
      0: 'Remember to sit up straight, keeping your shoulders low and relaxed.',
      1: 'Pay attention to the position of your hands; they should remain just above the keyboard level.',
      2: 'Be careful to keep your wrists relaxed, especially as the difficulty increases.',
      3: 'You should feel like you are playing with the metronome, not aiming for it.',
      4: 'When playing hands together, you should feel them playing together at the same tempo.',
      5: 'Make sure your seating height is properly adjusted. You need to sit up straight and relax your shoulders; your elbows should be at or slightly above the height of the keyboard keys.',
      6: 'Sometimes, it\'s better to take a short break. After a little pause (or a good night\'s sleep), difficulties tend to disappear!',
    },
    confirmationsTips: {
      0: 'Make sure to use the correct fingerings!',
      1: 'Listen to yourself carefully to ensure you are playing the right notes!',
    },
  },
  stepTransitionPanel: {
    buttons: {
      skip: 'Skip',
      restart: 'Restart',
      continue: 'Continue',
    }
  },
  classStepsPanel: {
    buttons: {
      hide: 'hide',
      courseMenu: 'Course menu',
      playNow: 'Play',
      backToSteps: 'Steps',
      continue: 'Continue',
    },
    welcome: {
      currentStep: 'In progress',
      alreadyDone: 'Already done',
      demo: 'Demonstration',
      cta: 'Start',
    },
  },
  classStepsBar: {
    buttons: {
      steps: 'Steps',
    }
  },
  sectionButton: {
    learn: 'Learn',
    toWorkOn: 'To work on!',
  },
  pianoClassPanel: {
    sectionsCount: 'This part contains {count} sections.',
    singleSection: 'This part contains only one section!',
    play: 'Play',
  },
  singClassPanel: {
    structureReminder: 'Structure Reminder',
    lyrics: 'Lyrics',
    sing: 'Sing',
  },
  classOverviewPanel: {
    quit: 'Leave',
  },
  partClassElement: {
    partType: {
      verse: 'Verse',
      chorus: 'Chorus',
      bridge: 'Bridge',
      intro: 'Intro',
      empty: 'Empty',
      other: 'Other',
    }
  },

  classTabContent: {
    teacherSuggests: 'TEACHER SUGGESTS',
    work: 'Work on',
    workName: 'Work on {name}',
    inProgress: 'In progress',
    continueNow: 'CONTINUE NOW',
    startNow: 'START NOW',
    reviewSkills: 'Review skills',
    allSkillsValidated: 'All skills are validated!',
    courseProgress: 'Course progress',
    review: 'Review',
    resume: 'Resume',
    replayPart: 'Replay {name}',
    resumePart: 'Resume {name}',
    playPart: 'Play {name}',
    playPartLockedTooltip: 'First validate sections {sections}',
    chain: 'Chain',
    validate: 'Validate',
    fullPiece: 'Full piece',
    replayPiece: 'Replay piece',
    chainFullPiece: 'Chain full piece',
    appearsIn: 'Appears in {name}',
    sectionsLabel: 'Sections: {list}',
    validateHint: 'Complete {name}',
    and: 'and',
    chainParts: 'Chain {p1} + {p2}',
  },
}